import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchVitalsBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Updates an existing vitals record. */
export function usePatchVitals() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, body }: { id: string; body: PatchVitalsBody }) => {
      const response = await api.patch('/vitals/:id', { params: { id }, body })
      if (!response.success) throw new Error(response.error.message)
      return response.data.vitals
    },
    onSuccess: (vitals) => {
      queryClient.invalidateQueries({ queryKey: ['patient-vitals', vitals.patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', vitals.patientId] })
      if (vitals.consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', vitals.consultationId] })
      }
    },
  })
}
